/**
 * SearchAiz Utils - Barrel Export
 *
 * Utility functions and registries for the SearchAiz component system.
 */

// Data source registry
export {
  DATA_SOURCE_REGISTRY,
  getDataSource,
  getAllDataSources,
  getDataSourcesByCategory,
  getDataSourcesByPattern,
  getDataSourcesWithReranking,
  getDataSourcesWithAnalysis,
  hasAccessToSource,
  filterAccessibleSources,
  getCollectionsForSources,
  getBestPatternForSources,
  canRerankSources,
  canAnalyzeSources,
  getSourceIcon,
  getSourceIconColor,
  getSourceBadgeColor,
  DEFAULT_SOURCES_BY_CONTEXT,
  getDefaultSourcesForContext,
} from './dataSourceRegistry';

// Settings resolver
export {
  DEFAULT_SETTINGS,
  DEFAULT_PORTAL_PERMISSIONS,
  DEFAULT_DEVELOPER_PERMISSIONS,
  resolveSettings,
} from './settingsResolver';
